import api from "./config";

// ============ Tarifa (los dos inputs: inicial y seguimiento) ============

export const getTarifaActual = async () => {
  try {
    const response = await api.get("/finanzas/tarifas/actual/");
    return response.data;
  } catch (error) {
    console.error("Error obteniendo tarifa actual:", error);
    return null;
  }
};

export const setTarifa = async (tarifa) => {
  try {
    const response = await api.post("/finanzas/tarifas/", tarifa);
    return response.data;
  } catch (error) {
    console.error("Error guardando tarifa:", error);
    return null;
  }
};

export const getTarifas = async () => {
  try {
    const response = await api.get("/finanzas/tarifas/");
    return response.data;
  } catch (error) {
    console.error("Error obteniendo tarifas:", error);
    return [];
  }
};

// ============ Cobro (ajuste manual de una consulta puntual) ============

export const addCobro = async (cobro) => {
  try {
    const response = await api.post("/finanzas/cobros/", cobro);
    return response.data;
  } catch (error) {
    console.error("Error agregando ajuste manual:", error);
    return null;
  }
};

export const updateCobro = async (id, cobro) => {
  try {
    const response = await api.patch(`/finanzas/cobros/${id}/`, cobro);
    return response.data;
  } catch (error) {
    console.error("Error actualizando ajuste manual:", error);
    return null;
  }
};

export const deleteCobro = async (id) => {
  try {
    await api.delete(`/finanzas/cobros/${id}/`);
    return true;
  } catch (error) {
    console.error("Error eliminando ajuste manual:", error);
    return false;
  }
};

// ============ Tablero ============

// modo: "hoy" | "semana" | "mes" | "anio" | "personalizado"
// compararContra: "periodo_anterior" | "anio_pasado"
// inicio / fin: "YYYY-MM-DD" (solo para modo "personalizado")
export const getTablero = async (
  modo = "mes",
  compararContra = "periodo_anterior",
  inicio = null,
  fin = null
) => {
  try {
    const params = new URLSearchParams({ modo, comparar_contra: compararContra });
    if (modo === "personalizado" && inicio && fin) {
      params.set("inicio", inicio);
      params.set("fin", fin);
    }
    const response = await api.get(`/finanzas/tablero/?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo tablero:", error);
    return null;
  }
};

// ============ Resumen Inicio ============

export const getResumenInicio = async () => {
  try {
    const response = await api.get("/finanzas/resumen-inicio/");
    return response.data;
  } catch (error) {
    console.error("Error obteniendo resumen de inicio:", error);
    return {
      citas_hoy: 0,
      citas_mes: 0,
      pacientes_registrados_mes: 0,
      consultas_mes: 0,
    };
  }
};